module.exports = __webpack_public_path__ + "img/Group 2796.570dd8ec.png";